import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SchoolmanagementService } from '../services/schoolmanagement.service';
import { UseraccessserviceService } from '../services/useraccessservice.service';
import { UtilService } from '../services/util.service';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent implements OnInit {

  constructor(private util: UtilService, private router: Router, private schoolmanager: SchoolmanagementService, private useraccessservice: UseraccessserviceService, private activatedroute: ActivatedRoute) { }

  async ngOnInit() {
    //debugger;
    // Cross-subdomain sign-on. The origins differ, so localStorage cannot carry a session and
    // the query string is the only channel.
    // ?handoff= is a 60-second, single-school code (not a session token), swapped for one here.
    // The ops console, the public site's "Enter School" and the subdomain rename in Create
    // School use it. After a successful swap the page reloads into the app, because startup
    // (offline session, admin menu) has already checked for a session before the swap finished.
    // A failed swap shows the API's message and keeps any session already on this device.
    // ?token= is the older form carrying the session token itself. Keep it: those callers fall
    // back to it, and external services may still rely on it. Do not remove this.
    // Every redirect below uses replaceUrl so the token-bearing entry does not stay in
    // browser history once it has been consumed.
    const handoff = this.activatedroute.snapshot.queryParams.handoff;
    if (handoff) {
      try {
        const res = await this.useraccessservice.redeemHandoff(handoff).toPromise();
        if (res?.token) {
          this.useraccessservice.setAuthenticatedUserToken(res.token);
          const target: string = this.activatedroute.snapshot.queryParams.url;
          // same-origin paths only, so the link cannot send anyone to another site
          window.location.replace(target && target.startsWith('/') && !target.startsWith('//') ? target : '/user/dashboard');
          return;
        }
      } catch (e) {
        console.error('[handoff] could not enter school', e);
      }
    }
    else if(this.activatedroute.snapshot.queryParams.token){
      this.useraccessservice.setAuthenticatedUserToken(this.activatedroute.snapshot.queryParams.token);
    }

      //const currentUserToken = this.useraccessservice.getCurrentUserToken();
      // let user;
      // //if(currentUserToken){
      //   user = await this.useraccessservice.isAlive().toPromise().catch(() => {
      //     user = null;
      //   });
      //}
      if(this.useraccessservice.getCurrentUserToken()){//if there is a user logged in
        //go to my courses
        //if you are a admin, go to the school page
        //if you have courses, go to the dashboard
        //else, go to the school page

        //let callerIsAdmin;
        //let studentHasCourses;
        //let tutorHasCourses;
      //   [callerIsAdmin/*, studentHasCourses, tutorHasCourses*/] = await Promise.all([this.util.checkUserIsSubdomainAdmin().toPromise()/*, 
      //                                                           this.util.checkStudentHasCourses().toPromise<boolean>(),
      // this.util.checkTutorHasCourses().toPromise<boolean>()*/]);

      //   if(callerIsAdmin){
      //     this.router.navigate(['/user/schoolhome']);
      //   }
      //   // else if(studentHasCourses || tutorHasCourses) {
      //   //   this.router.navigate(['/user/dashboard']);
      //   // }
      //   else{
      //     this.router.navigate(['/user/dashboard']);
      //   }     

        if (this.activatedroute.snapshot.queryParams.url) {
          this.router.navigateByUrl(this.activatedroute.snapshot.queryParams.url, { replaceUrl: true });
        }
        else{
          this.router.navigate(['/user/dashboard'], { replaceUrl: true });
        }
      }
      else{
        //debugger;
        // try{
        //   const schoolinfo: any = await this.schoolmanager.getSchoolFromSubdomain().toPromise();
        // }
        // catch(e){
        //   console.error(e);
        // }
        this.router.navigate(['/site/schoolhome'], { replaceUrl: true });
      }
    
  }

}
